export default "__VITE_ASSET__BPb854y1__"